/// <amd-module name="InstantSearch/Shared/RequestManager" />
/**
 * Class to avoid race condition among requests. It marks the request invalid
 * if it resolves after any of the next ones.
 */
export class RequestManager {
    private _requestId = 0;
    private _lastResolvedRequestId = -1;

    public get newRequestId(): number {
        return this._requestId++;
    }

    public isValidRequest(requestId: number): boolean {
        if (requestId > this._lastResolvedRequestId) {
            this._lastResolvedRequestId = requestId;
            return true;
        }

        return false;
    }
}
